<template>
    <div v-wechat-title="message.title">
        <cus-form ref="form-message" :columns="columnList" :data="message.data" @confirm="saveMessage"></cus-form>
        <div class="dialog-footer align-right">
            <el-button @click="confirm">取 消</el-button>
            <el-button type="primary" @click="confirmMessage">确 定</el-button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `AnesthsiaMessageSend`,
    props: {

    },
    data() {
        return {
            usergroup: [],
            surgeryId: this.$route.query.surgery_id,
            recordType: this.$route.query.recordType,
            operatingRoomName: ``,
            token: this.$route.query.token,
            isbobao: true,
            sendtypedefault: 1,
            templateList: [],
            templateoption: [],
            users: [],
            msg: `closeWindow`,
            message: {
                dialogFormVisible: true,
                data: {},
                title: `创建消息通知`,
                messageId: 0
            }
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
            this.$store.dispatch(`ADD_WARD_AUTH`)
            this.$store.dispatch(`enums/ADD_ALL_ENUM`)
            this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
            this.$store.dispatch(`ADD_RECOVERY_WARD_AUTH`)
        }
        this.loadSurgery()
        this.loadUsers()
        this.loadGroup()
    },
    computed: {
        ...mapGetters([`sys_enums`, `ward_auth`, `operation_ward_auth`, `operation_room_auth`, `recovery_ward_auth`, `recovery_bed_auth`, `screenHeight`]),
        templateoptioncomputed() {
            let sendtype = 1
            if (this.isbobao === true) {
                sendtype = 1
            } else {
                sendtype = 2
            }
            let r = _.filter(this.templateoption, d => { return d.type === sendtype })
            return r
        },
        columnList() {
            let me = this
            let viewlist = [
                {
                    type: `radio`,
                    prop: `send_type`,
                    label: `通知形式`,
                    colspan: 24,
                    width: `100`,
                    isCreatable: true,
                    default: this.sendtypedefault,
                    options: [{ label: `播报`, value: 1 }, { label: `信息`, value: 2 }],
                    change: (that, { row }) => {
                        this.sendtypedefault = row.send_type
                        if (row.send_type == 2) {
                            this.isbobao = false
                        } else {
                            this.isbobao = true
                        }
                        this.$set(row, `title`, undefined)
                        this.$set(row, `content`, undefined)
                        this.$set(row, `play_time`, undefined)
                        this.$set(row, `play_interval`, undefined)
                        this.$set(row, `sys_board_template_id`, undefined)
                        this.$set(row, `notice_location`, undefined)
                        this.$set(row, `all`, undefined)
                        this.$set(row, `sys_message_group_array`, undefined)
                        this.$set(row, `ac_sys_user_array`, undefined)
                    }
                }, {
                    type: `select`,
                    prop: `sys_board_template_id`,
                    label: `选择模板`,
                    width: `200`,
                    colspan: 24,
                    isCreatable: true,
                    options: this.templateoptioncomputed,
                    change: (that, { row }) => {
                        let template = this.templateList.find(s => s.id == row.sys_board_template_id)
                        if (template) {
                            console.log(template)
                            this.$set(row, `send_type`, template.send_type)
                            this.$set(row, `title`, template.title)
                            this.$set(row, `content`, me.operatingRoomName + template.content)
                            this.$set(row, `play_time`, template.play_time)
                            this.$set(row, `play_interval`, template.play_interval)
                            if (template.send_type === 1) {
                                this.isbobao = true
                                this.$set(row, `notice_location`, template.dic_ward_ids)
                            } else if (template.send_type === 2) {
                                this.isbobao = false
                                this.$set(row, `all`, template.all)
                                this.$set(row, `sys_message_group_array`, template.sys_messagegroup_ids)
                                this.$set(row, `ac_sys_user_array`, template.ac_sysUser_ids)
                            }
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `title`,
                    label: `通知标题`,
                    colspan: 24,
                    width: `200`,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }, {
                    type: `textarea`,
                    prop: `content`,
                    label: `内容`,
                    colspan: 24,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: {
                        minRows: 6,
                        maxRows: 6
                    }
                },
                {
                    type: `number`,
                    prop: `play_time`,
                    label: `播放次数`,
                    colspan: 12,
                    width: `200`,
                    isListable: true,
                    default: 1,
                    isCreatable: this.isbobao
                },
                {
                    type: `number`,
                    prop: `play_interval`,
                    label: `播放间隔(秒)`,
                    colspan: 12,
                    width: `200`,
                    default: 1,
                    isCreatable: this.isbobao
                }, {
                    type: `selecttree`,
                    prop: `notice_location`,
                    label: `通知位置`,
                    colspan: 24,
                    showCount: 11,
                    options: this.loadnoticelocation,
                    isCreatable: this.isbobao,
                    collapseTags: false,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `checkbox`,
                    prop: `all`,
                    colspan: 24,
                    label: `全部`,
                    isCreatable: !this.isbobao
                }, {
                    type: `multiselect`,
                    prop: `sys_message_group_array`,
                    label: `接收组`,
                    colspan: 12,
                    options: this.usergroup,
                    collapseTags: false,
                    isCreatable: !this.isbobao,
                    isEditable: !this.isbobao
                }, {
                    type: `multiselect`,
                    prop: `ac_sys_user_array`,
                    label: `接收人`,
                    colspan: 12,
                    options: this.users,
                    collapseTags: false,
                    isCreatable: !this.isbobao,
                    isEditable: !this.isbobao
                }]
            return _.filter(viewlist, d => {
                return d.isCreatable == true
            })
        }

    },
    mounted() {
    },
    methods: {
        loadSurgery() {
            let that = this
            if (!that.surgeryId) return
            let req = that.myaxios.get(`/api/Preoperative/Apply/Get/${that.surgeryId}`)
            req.then(data => {
                if (data) {
                    that.operatingRoomName = that.recordType == 2 ? data.dic_recovery_ward : data.dic_operating_room
                }
            }).catch(e => console.log(e))
        },
        loadUsers() {
            let req = this.myaxios.get(`/api/AcisSystem/SysUser/Get`)
            req.then((data) => {
                this.users = _.map(data, d => {
                    return {
                        value: d.id,
                        label: d.dic_worker_name || `--`,
                        code: d.username,
                        disabled: d.is_deleted
                    }
                })
            }).catch(e => {
                console.log(e)
            })
        },
        loadnoticelocation() {
            let options = []
            options.push({
                label: `显示屏`,
                value: `dp_xsp_1`,
                jianpin: `xsp`,
                code: `xsp`,
                children: [{
                    label: `排程屏`,
                    value: `dp_pc_1`,
                    jianpin: `pcp`,
                    code: `pcp`,
                    parent_value: `dp_xsp_1`
                }]
            })
            this.ward_auth.map(ward => {
                let wardoption = {
                    label: `${ward.label}`,
                    value: `${ward.value}`,
                    jianpin: `${ward.jianpin}`,
                    code: `${ward.code}`
                }
                let children = []
                if (ward.operation_room && ward.operation_room.length > 0) {
                    ward.operation_room.map(room => {
                        children.push({
                            label: room.label,
                            value: `${ward.value}_${room.value}`,
                            jianpin: room.jianpin,
                            code: room.jianpin,
                            parent_value: `${ward.value}`
                        })
                    })
                } else if (ward.recovery_bed && ward.recovery_bed.length > 0) {
                    ward.recovery_bed.map(room => {
                        children.push({
                            label: room.label,
                            value: `${ward.value}_${room.value}`,
                            jianpin: room.jianpin,
                            code: room.jianpin,
                            parent_value: `${ward.value}`
                        })
                    })
                }
                if (children.length > 0) {
                    wardoption.children = children
                }
                options.push(wardoption)
            })
            return options
        },
        loadGroup() {
            let req = this.myaxios.get(`/api/AcisSystem/MessageGroup/Get`)
            req.then(data => {
                this.usergroup = data && data.map(d => {
                    return {
                        label: d.name,
                        value: d.id,
                        ac_sys_user_id: d.ac_sys_user_id
                    }
                })
            })
        },
        loadTemplate() {
            let that = this
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/AcisSystem/BoardTemplate/Get`)
                req.then(data => {
                    _.map(data, d => {
                        let roomIds = d.dic_operating_room_id && _.split(d.dic_operating_room_id, `,`).map(p => parseInt(p)) || []
                        let bedIds = d.dic_recovery_bed_id && _.split(d.dic_recovery_bed_id, `,`).map(p => parseInt(p)) || []
                        let orooms = []
                        let rbeds = []
                        _.forEach(this.ward_auth, ward => {
                            if (_.has(ward, `operation_room`)) {
                                let wardRoomIds = ward.operation_room.map(o => o.value)
                                let childRoomIds = roomIds.filter(x => wardRoomIds.includes(x))
                                childRoomIds.map(p => {
                                    p = `${ward.value}_${p}`
                                    orooms.push(p)
                                })
                            } else {
                                let wardBedIds = ward.recovery_bed.map(o => o.value)
                                let childBedIds = bedIds.filter(x => wardBedIds.includes(x))
                                childBedIds.map(p => {
                                    p = `${ward.value}_${p}`
                                    rbeds.push(p)
                                })
                            }
                        })
                        d.board_type && _.split(d.board_type, `,`).map(p => {
                            p = `dp_pc_${p}`
                            rbeds.push(p)
                        })

                        let wards = orooms.concat(rbeds)

                        d.dic_ward_ids = wards

                        d.sys_messagegroup_ids = d.sys_messagegroup_ids && _.split(d.sys_messagegroup_ids, `,`).map(p => parseInt(p))
                        let users = d.ac_sysUser_ids && _.split(d.ac_sysUser_ids, `,`).map(p => parseInt(p))
                        if (users && users.length == 1 && users[0] == 0) {
                            d.ac_sysUser_ids = []
                            d.all = true
                        } else {
                            d.all = false
                            d.ac_sysUser_ids = users
                        }

                        d.modify_date = this.$moment(d.modify_date).format(`YYYY/MM/DD HH:mm`)
                    })

                    data = _.filter(data, r => {
                        return r.send_type && r.send_type > 0
                    })
                    if (that.dic_ward_id) {
                        data = _.filter(data, r => {
                            return _.includes(r.dic_ward_ids, that.dic_ward_id) || r.send_type == 2
                        })
                    }
                    this.templateList = data
                    this.templateoption = data.map(item => {
                        return {
                            label: item.name,
                            value: item.id,
                            type: item.send_type
                        }
                    })
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                    resolve([])
                })
            })
        },
        confirmMessage() {
            this.$refs[`form-message`].confirm()
        },
        saveMessage(row) {
            let that = this
            return new Promise((resolve, reject) => {
                row.enum_message_status = 0 // 已保存
                row.biz_id = that.surgeryId || null
                row.biz_type = 500 // 麻醉单播报
                // 内容解析
                if (row.send_type == 1 && row.notice_location) {
                    let dicoperatingwardid = []
                    let dicoperatingroomid = []
                    let dicrecoverywardid = []
                    let dicrecoverybedid = []
                    let boardtype = ``
                    row.notice_location.map(item => {
                        // item 格式为 rw_手术区id_手术间id
                        let itemarr = item.split(`_`)
                        let pvalue = itemarr[0] + `_` + itemarr[1]
                        let pitemvalue = parseInt(itemarr[1])
                        let itemvalue = parseInt(itemarr[2])
                        // 找对应的手术区或者复苏区
                        let auth = _.find(this.ward_auth, { value: pvalue })
                        if (item.indexOf(`all`) > -1) {
                            if (item.indexOf(`ow`) > -1) {
                                if (!dicoperatingwardid.includes(pitemvalue)) {
                                    dicoperatingwardid.push(pitemvalue)
                                }
                                auth.operation_room.map(r => {
                                    if (!dicoperatingroomid.includes(r.value)) {
                                        dicoperatingroomid.push(r.value)
                                    }
                                })
                            } else if (item.indexOf(`rw`) > -1) {
                                if (!dicrecoverywardid.includes(pitemvalue)) {
                                    dicrecoverywardid.push(pitemvalue)
                                }
                                auth.recovery_bed.map(r => {
                                    if (!dicrecoverybedid.includes(r.value)) {
                                        dicrecoverybedid.push(r.value)
                                    }
                                })
                            }
                        } else if (item.indexOf(`dp`) > -1) {
                            boardtype = itemvalue
                        } else if (item.indexOf(`ow`) > -1) {
                            if (!dicoperatingroomid.includes(itemvalue)) {
                                dicoperatingroomid.push(itemvalue)
                            }
                            if (!dicoperatingwardid.includes(pitemvalue)) {
                                dicoperatingwardid.push(pitemvalue)
                            }
                        } else if (item.indexOf(`rw`) > -1) {
                            if (!dicrecoverybedid.includes(itemvalue)) {
                                dicrecoverybedid.push(itemvalue)
                            }
                            if (!dicrecoverywardid.includes(pitemvalue)) {
                                dicrecoverywardid.push(pitemvalue)
                            }
                        }
                    })
                    row.dic_operating_room_array = dicoperatingroomid
                    row.dic_operating_ward_array = dicoperatingwardid
                    row.dic_recovery_bed_array = dicrecoverybedid
                    row.dic_recovery_ward_array = dicrecoverywardid
                    row.board_type = boardtype
                } else if (row.send_type == 2) {
                    let gs = _.filter(that.usergroup, d => (row.sys_message_group_array || []).indexOf(d.value) > -1)
                    gs = _.flatMap(gs, d => d.ac_sys_user_id)
                    gs = _.uniq(gs.concat(row.ac_sys_user_array || []))
                    if (!row.all && gs.length == 0) {
                        this.$message.warning(`请选择接收人`)
                        return
                    }
                }
                let req = this.myaxios.post(`/api/Operation/MessageHeader/Save`, row)
                req.then(data => {
                    // 消息发送
                    row.id = data.id
                    console.log(row)
                    if (data) {
                        that.sendMessageNew(data.id)
                    }
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        sendMessageNew(msgId) {
            let that = this
            let req = that.myaxios.post(`/api/Operation/MessageReceive/PostNew?messageId=${msgId}`)
            req.then(data => {
                this.$message.info(`已通知`)
                this.confirm()
            }).catch(e => console.log(e))
        },
        sendMessage(row) {
            // 消息发送
            if (row.send_type == 2) {
                let gs = _.filter(this.usergroup, d => (row.sys_message_group_array || []).indexOf(d.value) > -1)
                gs = _.flatMap(gs, d => d.ac_sys_user_id)
                gs = _.uniq(gs.concat(row.ac_sys_user_array || []))
                if (!row.all && gs.length == 0) {
                    this.$message.warning(`请选择接收人`)
                    return
                }
                let req = this.myaxios.post(`/api/Operation/MessageReceive/Post?messageId=${row.id}`, row.all ? [0] : gs)
                req.then(() => {
                    this.$message.info(`已通知`)
                    this.confirm()
                })
            } else {
                let dicoperatingwardid = []
                let dicoperatingroomid = []
                let dicrecoverywardid = []
                let dicrecoverybedid = []
                let boardtype = ``
                row.notice_location.map(item => {
                    // item 格式为 rw_手术区id_手术间id
                    let itemarr = item.split(`_`)
                    let pvalue = itemarr[0] + `_` + itemarr[1]
                    let pitemvalue = parseInt(itemarr[1])
                    let itemvalue = parseInt(itemarr[2])
                    // 找对应的手术区或者复苏区
                    let auth = _.find(this.ward_auth, { value: pvalue })
                    if (item.indexOf(`all`) > -1) {
                        if (item.indexOf(`ow`) > -1) {
                            if (!dicoperatingwardid.includes(pitemvalue)) {
                                dicoperatingwardid.push(pitemvalue)
                            }
                            auth.operation_room.map(r => {
                                if (!dicoperatingroomid.includes(r.value)) {
                                    dicoperatingroomid.push(r.value)
                                }
                            })
                        } else if (item.indexOf(`rw`) > -1) {
                            if (!dicrecoverywardid.includes(pitemvalue)) {
                                dicrecoverywardid.push(pitemvalue)
                            }
                            auth.recovery_bed.map(r => {
                                if (!dicrecoverybedid.includes(r.value)) {
                                    dicrecoverybedid.push(r.value)
                                }
                            })
                        }
                    } else if (item.indexOf(`dp`) > -1) {
                        boardtype = itemvalue
                    } else if (item.indexOf(`ow`) > -1) {
                        if (!dicoperatingroomid.includes(itemvalue)) {
                            dicoperatingroomid.push(itemvalue)
                        }
                        if (!dicoperatingwardid.includes(pitemvalue)) {
                            dicoperatingwardid.push(pitemvalue)
                        }
                    } else if (item.indexOf(`rw`) > -1) {
                        if (!dicrecoverybedid.includes(itemvalue)) {
                            dicrecoverybedid.push(itemvalue)
                        }
                        if (!dicrecoverywardid.includes(pitemvalue)) {
                            dicrecoverywardid.push(pitemvalue)
                        }
                    }
                })
                row.dic_operating_room_array = dicoperatingroomid
                row.dic_operating_ward_array = dicoperatingwardid
                row.dic_recovery_bed_array = dicrecoverybedid
                row.dic_recovery_ward_array = dicrecoverywardid
                row.board_type = boardtype
                row.enum_message_status = 1
                row.surgeryId = this.surgeryId || null
                row.type = `BB`

                _.each(row, (value, key) => {
                    /* eslint valid-typeof: "error" */
                    if (row[key] && (row[key] + ``).indexOf(`/Date`) > -1) {
                        row[key] = this.$moment(row[key]).format(`YYYY/MM/DD HH:mm`)
                    }
                })

                let msgData = JSON.stringify(row)
                // 播报发送
                let req = this.myaxios.post(`/api/Operation/BoardNotice/SendMessage?msg=${msgData}`)
                req.then(data => {
                    this.$message.info(`已通知`)
                    this.confirm()
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        confirm() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: ``,
                    action: this.msg
                }
                winformMsg.acceptMessage(cefJson)
            }
        }
    },
    watch: {
        ward_auth: function() {
            this.loadTemplate()
        }
    }
}
</script>
<style scoped lang="less">
/deep/.el-select__tags-text {
    max-width: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Message/AnesthsiaMessageSend.vue